<div
    bsModal
    #createOrEditModal="bs-modal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="createOrEditModal"
    aria-hidden="true"
    [config]="{ backdrop: 'static' }"
>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form #brandForm="ngForm" novalidate (ngSubmit)="save()" autocomplete="off">
                <div class="modal-header">
                    <h4 class="modal-title">
                        <span *ngIf="brand.id">{{ l('EditBrand') }}</span>

                        <span *ngIf="!brand.id">{{ l('CreateNewBrand') }}</span>
                    </h4>

                    <button
                        type="button"
                        class="btn-close"
                        (click)="close()"
                        aria-label="Close"
                        [disabled]="saving"
                    ></button>
                </div>
                <div class="modal-body">
                    <div class="my-3">
                        <label class="form-label" for="Brand_Name">{{ l('Name') }} *</label>
                        <input
                            type="text"
                            #Brand_Name="ngModel"
                            id="Brand_Name"
                            class="form-control"
                            [(ngModel)]="brand.name"
                            name="Name"
                            minlength="0"
                            maxlength="500"
                            required
                        />
                        <validation-messages [formCtrl]="Brand_Name"></validation-messages>
                    </div>
                </div>
                <div class="modal-footer">
                    <button [disabled]="saving" type="button" class="btn btn-danger" (click)="close()">
                        {{ l('Cancel') }}
                    </button>
                    <button
                        type="submit"
                        class="btn btn-primary blue"
                        [disabled]="!brandForm.form.valid"
                        [buttonBusy]="saving"
                        [busyText]="l('SavingWithThreeDot')"
                    >
                        <i class="fa fa-save"></i>
                        <span>{{ l('Save') }}</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
